import axios from "axios";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const { REACT_APP_API_ENDPOINT } = process.env;

export const getAboutUs = createAsyncThunk("get/about_us", async () => {
  const resp = await axios.get(
    `${REACT_APP_API_ENDPOINT}/api/v2/posts/about_us/`
  );
  return resp.data;
});

const initialState = {
  aboutUsList: [],
};

const AboutUsListSlice = createSlice({
  name: "AboutUsList",
  initialState,
  reducers: {
    resetState: () => initialState,
  },
  extraReducers: {
    [getAboutUs.fulfilled]: (state, action) => {
      state.aboutUsList = action.payload;
    },
    [getAboutUs.rejected]: () => {
      alert("Get office failed!");
    },
  },
});

export default AboutUsListSlice.reducer;
